import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import "@/App.css";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import CustomRequestPage from "./pages/CustomRequestPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminPage from "./pages/AdminPage";
import TrackOrderPage from "./pages/TrackOrderPage";
import OrdersPage from "./pages/OrdersPage";
import FortnitePage from "./pages/FortnitePage";
import SportsPage from "./pages/SportsPage";
import { CartProvider } from "./context/CartContext";
import ChatWidget from "./components/ChatWidget";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/product/:slug" element={<ProductDetailPage />} />
            <Route path="/coming-soon" element={<ComingSoonPage />} />
            <Route path="/custom-request" element={<CustomRequestPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/track" element={<TrackOrderPage />} />
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/fortnite" element={<FortnitePage />} />
            <Route path="/sports" element={<SportsPage />} />
          </Routes>
          <ChatWidget />
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#141414",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "#fff",
                fontFamily: "IBM Plex Sans, sans-serif",
              },
            }}
          />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
